/* eslint-disable no-redeclare */
// TODO: remove code above and fix issues in case changing this file
'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileFleetServices', cobCarrierProfileFleetServices);

	cobCarrierProfileFleetServices.$inject = [
		'$location', '$timeout', 'sessionService', 'subjectObserverMessagesService', 'observerService',
		'carrierRegistrationService', 'carrierDocumentsService', '$stateParams', 'spinnerService'
	];

	var HAZMAT_DOCUMENT_TYPE = 'HazMat Cert';
	var TWIC_DOCUMENT_TYPE = 'TWIC Card';

	var HAZMAT_DOCUMENT_HEADER_INFO = 'Please upload an image of your Hazmat Certificate(s)';
	var TWIC_DOCUMENT_HEADER_INFO = 'Please upload an image of your TWIC Card(s)';

	var HAZMAT_UPLOADED_MESSAGE = 'You can upload more Hazmat certificate(s).';
	var TWIC_UPLOADED_MESSAGE = 'You can upload more TWIC card(s).';

	var $location,
		$timeout,
		sessionService,
		subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		carrierDocumentsService,
		$stateParams,
		spinnerService;
	var subjectMessages, observerMessages;

	function cobCarrierProfileFleetServices(
		_$location_,
		_$timeout_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_carrierDocumentsService_,
		_$stateParams_,
		_spinnerService_) {
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		carrierDocumentsService = _carrierDocumentsService_;
		$timeout = _$timeout_;
		$location = _$location_;
		$stateParams = _$stateParams_;
		spinnerService = _spinnerService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileFleetServices.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				isBroker: sessionService.isBroker(),
				isAdmin: sessionService.isAuthorizedInternalAdmin(),
				isDirty: false,
				showSectionMessage: false,
				hazmatUploadResult: {
					succeeded: true,
					errorMessage: ''
				}
			};

			scope.hazmatDocumentHeaderInfo = HAZMAT_DOCUMENT_HEADER_INFO;
			scope.twicDocumentHeaderInfo = TWIC_DOCUMENT_HEADER_INFO;

			scope.hazmatUploadedMessage = HAZMAT_UPLOADED_MESSAGE;
			scope.twicUploadedMessage = TWIC_UPLOADED_MESSAGE;

			scope.carrierId = $stateParams.carrierId;
			scope.setIsDirty = setIsDirty;
			scope.isValidNumberOfPowerUnits = isValidNumberOfPowerUnits;
			scope.isValidNumberOfOwnerOperators = isValidNumberOfOwnerOperators;
			scope.isValidNumberOfCompanyDrivers = isValidNumberOfCompanyDrivers;
			scope.isValidTrailerCounts = isValidTrailerCounts;
			scope.isFormValid = isFormValid;
			scope.textFieldKeyDown = textFieldKeyDown;
			scope.textFieldBlur = textFieldBlur;
			scope.goToTab = goToTab;
			scope.loadData = loadData;
			scope.clearTrailerCounts = clearTrailerCounts;
			scope.clearVanTypes = clearVanTypes;
			scope.clearFlatbedTypes = clearFlatbedTypes;
			scope.clearTrailerAttributes = clearTrailerAttributes;
			scope.onChangeHasDangerousGoods = onChangeHasDangerousGoods;
			scope.onChangeHasInternational = onChangeHasInternational;
			scope.onChangeHasSecurityCerts = onChangeHasSecurityCerts;
			scope.onChangeHasEnvironmentalCerts = onChangeHasEnvironmentalCerts;
			scope.onChangeHasLtlCapabilities = onChangeHasLtlCapabilities;
			scope.onChangeHasDropOffPort = onChangeHasDropOffPort;
			scope.onChangeIsPortDrayage = onChangeIsPortDrayage;
			scope.onChangeIsAirCartage = onChangeIsAirCartage;
			scope.onForceGo = onForceGo;
			scope.saveData = saveData;
			scope.setPendingTab = setPendingTab;
			scope.uploadHazmatFile = uploadHazmatFile;
			scope.uploadTwicFile = uploadTwicFile;

			scope.ux_requirement_hack_for_scrolling = false;

			registerObserverHandlers();
			loadData();
			document.title = 'Profile-Fleet';

			$timeout(function() {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
			},
			100);
		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_START_CHANGE_CARRIER_PROFILE_VIEW, handler: saveData },
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_VIEW_IS_DIRTY, handler: setIsDirty },
					{ message: observerMessages.COB_OBSERVER_SET_PENDING_TAB, handler: setPendingTab }
				]);

			scope.$on('$destroy',
				function() {
					window.onbeforeunload = undefined;
				});

			scope.$on('$locationChangeStart',
				function(event) {
					if (scope.m.isDirty) {
						if (!scope.ux_requirement_hack_for_scrolling) {
							if (!confirm('You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page. Are you sure you want to leave the page?')) {
								event.preventDefault();
							}
						}
					}

					scope.ux_requirement_hack_for_scrolling = false;
				});
		}

		function setIsDirty() {
			scope.m.isDirty = true;
			window.onbeforeunload = function() {
				return 'You have unsaved data. If you leave this page any changes will be lost. Changes are saved using the Save buttons at the bottom of the page.';
			};
		}

		function textFieldKeyDown(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			var isShift = !!event.shiftKey;

			if (isShift) {
				switch (charCode) {
				case 220: // | character
				case 222: // '
					event.preventDefault();
				}
			}
		}

		function textFieldBlur() {
			if (scope.m.otherServices != undefined) {
				scope.m.otherServices = scope.m.otherServices.replace(/\|/g, ' ');
				scope.m.otherServices = scope.m.otherServices.replace(/'/g, ' ');
			}

			if (scope.m.airCartageAirports != undefined) {
				scope.m.airCartageAirports = scope.m.airCartageAirports.replace(/\|/g, ' ');
				scope.m.airCartageAirports = scope.m.airCartageAirports.replace(/'/g, ' ');
			}

			if (scope.m.portDrayageCities != undefined) {
				scope.m.portDrayageCities = scope.m.portDrayageCities.replace(/\|/g, ' ');
				scope.m.portDrayageCities = scope.m.portDrayageCities.replace(/'/g, ' ');
			}
		}

		function loadData() {
			var carrierId = getCarrierId();

			carrierRegistrationService.lookupCarrierFleetServices(carrierId)
				.then(function(response) {

					scope.m.hasDangerousGoods = response.data.hasDangerousGoods;
					scope.m.hasInternational = response.data.hasInternational;
					scope.m.hasEnvironmentalCerts = response.data.hasEnvironmentalCerts;
					scope.m.hasLtlCapabilities = response.data.hasLtlCapabilities;
					scope.m.hasDropOffPort = response.data.hasDropOffPort;
					scope.m.hasNoTrailers = response.data.hasNoTrailers;
					scope.m.hasSecurityCerts = response.data.hasSecurityCerts;

					if (response.data.equipment != null) {
						scope.m.numberOfPowerUnits = response.data.equipment.numberOfPowerUnits;
						scope.m.numberOfOwnerOperators = response.data.equipment.numberOfOwnerOperators;
						scope.m.numberOfCompanyDrivers = response.data.equipment.numberOfCompanyDrivers;
						scope.m.numberOfTeams = response.data.equipment.numberOfTeams;
						scope.m.onBoardCommunications = response.data.equipment.communicationType;
						scope.m.hasAirRide = response.data.equipment.hasAirRide;
						scope.m.hasChains = response.data.equipment.hasChains;
						scope.m.hasCoilRacks = response.data.equipment.hasCoilRacks;
						scope.m.hasConestoga = response.data.equipment.hasConestoga;
						scope.m.hasContainerLocks = response.data.equipment.hasContainerLocks;
						scope.m.hasCurtains = response.data.equipment.hasCurtains;
						scope.m.hasEtrac = response.data.equipment.hasEtrac;
						scope.m.hasGarmentRacks = response.data.equipment.hasGarmentRacks;
						scope.m.hasHotshot = response.data.equipment.hasHotshot;
						scope.m.hasInsulated = response.data.equipment.hasInsulated;
						scope.m.hasPadWrap = response.data.equipment.hasPadWrap;
						scope.m.hasStraps = response.data.equipment.hasStraps;
						scope.m.hasTarps = response.data.equipment.hasTarps;
						scope.m.hasVented = response.data.equipment.hasVented;
					}

					if (response.data.services != null) {
						scope.m.isBrokerage = response.data.services.doesBrokerage;
						scope.m.isMultiStop = response.data.services.doesMultipleStops;
						scope.m.isPalletExchange = response.data.services.doesPalletExchange;
						scope.m.isParcel = response.data.services.doesParcels;
						scope.m.isTrailerInterchange = response.data.services.doesTrailerInterchange;
						scope.m.isAirCartage = response.data.services.handlesAirFreightCartage;
						scope.m.isEdi = response.data.services.handlesEdi;
						scope.m.isLargeLoad = response.data.services.handlesOversizeLoads;
						scope.m.isPortDrayage = response.data.services.handlesPortDryage;
						scope.m.isRailDrayage = response.data.services.handlesRailDryage;
						scope.m.isCarbCompliant = response.data.services.hasCarbCompliantTrucks;
						scope.m.isExpeditedGround = response.data.services.hasExpeditedGround;
						scope.m.isSpottedTrailers = response.data.services.hasSpottedTrailers;
						scope.m.isAceCertified = response.data.services.isAceCertified;
						scope.m.is100PctCarbCompliant = response.data.services.isCarbComplientTru;
						scope.m.isCtpatMember = response.data.services.isCtpatMember;
						scope.m.isHazmatCertified = response.data.services.isHazmatCertified;
						scope.m.isRadioactiveCertified = response.data.services.isRadioactiveCertified;
						scope.m.isResponsibleCareCarrier = response.data.services.isResponsibileCare;
						scope.m.isSmartWayCarrier = response.data.services.isSmartwayCarrier;
						scope.m.isTsaRegistered = response.data.services.isTsaRegistered;
						scope.m.isTwicCardholder = response.data.services.isTwicCardholder;
						scope.m.isUpsCarrier = response.data.services.isUpsCarrier;
						scope.m.otherServices = response.data.services.otherServices;
						scope.m.isLtlCapabilities = response.data.services.hasLtlCapabilties;

						if (response.data.services.airports != null) {
							var airportCount = response.data.services.airports.length;
							if (airportCount > 0) {
								scope.m.airCartageAirports = '';
								for (var i = 0; i < airportCount; i++) {
									scope.m.airCartageAirports += response.data.services.airports[i] + '\n';
								}
							}
						}

						if (response.data.services.ports != null) {
							var portCount = response.data.services.ports.length;
							if (portCount > 0) {
								scope.m.portDrayageCities = '';
								for (var i = 0; i < portCount; i++) {
									scope.m.portDrayageCities += response.data.services.ports[i] + '\n';
								}
							}
						}

					}

					if (response.data.equipment != null) {

						var arrayLength = response.data.equipment.trailers.length;

						for (var i = 0; i < arrayLength; i++) {
							switch (response.data.equipment.trailers[i].trailerType.toLowerCase()) {
							case 'flatbed48ft':
								scope.m.flatbeds48 = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'flatbed53ft':
								scope.m.flatbeds53 = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'van48ft':
								scope.m.vans48 = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'van53ft':
								scope.m.vans53 = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'reefer48ft':
								scope.m.reefers48 = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'reefer53ft':
								scope.m.reefers53 = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'doubledrop':
								scope.m.doubleDropCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'lowboy':
								scope.m.lowBoyCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'autocarrier':
								scope.m.autoCarrierCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'container':
								scope.m.containerCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'movingvan':
								scope.m.movingVanCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'dropstep':
								scope.m.dropStepDeckCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'dumptrailer':
								scope.m.dumpTrailerCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'stretchtrailer':
								scope.m.stretchTrailerCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'hopperbottom':
								scope.m.hopperBottomCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'tanker':
								scope.m.tankerCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							case 'straighttruck':
								scope.m.straightTruckCount = response.data.equipment.trailers[i].trailerAmount;
								break;
							default:
								break;
							}
						}
					}

					$timeout(function() {
						clearVanTypes();
						clearFlatbedTypes();
						clearTrailerAttributes();
						onChangeHasDangerousGoods();
						onChangeHasInternational();
						onChangeHasSecurityCerts();
						onChangeHasEnvironmentalCerts();
						onChangeHasLtlCapabilities();
						onChangeHasDropOffPort();
						onChangeIsPortDrayage();
						onChangeIsAirCartage();

						scope.m.isDirty = false;
						window.onbeforeunload = undefined;
					});

					loadDocuments();
				})
				.catch(function(e) {
					console.log(e);
				});

		}

		function getCarrierId() {
			return $stateParams.carrierId ? $stateParams.carrierId : -1;
		}

		function clearTrailerCounts() {
			if (scope.m.hasNoTrailers) {
				scope.m.vans48 = null;
				scope.m.vans53 = null;
				scope.m.flatbeds48 = null;
				scope.m.flatbeds53 = null;
				scope.m.reefers48 = null;
				scope.m.reefers53 = null;
				scope.m.containerCount = null;
				scope.m.movingVanCount = null;
				scope.m.straightTruckCount = null;
				scope.m.tankerCount = null;
				scope.m.autoCarrierCount = null;
				scope.m.doubleDropCount = null;
				scope.m.dropStepDeckCount = null;
				scope.m.lowBoyCount = null;
				scope.m.stretchTrailerCount = null;
				scope.m.dumpTrailerCount = null;

				if (flatbedsCountIsZero()) {
					scope.m.hopperBottomCount = null;
				}

				clearTrailerAttributes();
			}
		}

		function clearVanTypes() {
			if (vansCountIsZero()) {
				scope.m.containerCount = null;
				scope.m.movingVanCount = null;
				scope.m.straightTruckCount = null;
				scope.m.tankerCount = null;
				scope.m.hopperBottomCount = null;

				if (flatbedsCountIsZero()) {
					scope.m.hopperBottomCount = null;
				}
			}

			clearTrailerAttributes();
		}

		function clearFlatbedTypes() {
			if (flatbedsCountIsZero()) {
				scope.m.autoCarrierCount = null;
				scope.m.doubleDropCount = null;
				scope.m.dropStepDeckCount = null;
				scope.m.lowBoyCount = null;
				scope.m.stretchTrailerCount = null;
				scope.m.dumpTrailerCount = null;

				if (vansCountIsZero()) {
					scope.m.hopperBottomCount = null;
				}
			}

			clearTrailerAttributes();
		}

		function clearTrailerAttributes() {
			if (vansCountIsZero()) {
				scope.m.hasCurtains = false;
				scope.m.hasGarmentRacks = false;
				scope.m.hasPadWrap = false;
			}

			if (flatbedsCountIsZero()) {
				scope.m.hasChains = false;
				scope.m.hasCoilRacks = false;
				scope.m.hasStraps = false;
				scope.m.hasTarps = false;
			}

			if (vansCountIsZero() && flatbedsCountIsZero()) {
				scope.m.hasConestoga = false;
				scope.m.hasHotshot = false;
			}

			if (vansCountIsZero() && flatbedsCountIsZero() && reefersCountIsZero()) {
				scope.m.hasAirRide = false;
			}
			if (vansCountIsZero() && reefersCountIsZero()) {
				scope.m.hasInsulated = false;
				scope.m.hasVented = false;
				scope.m.hasContainerLocks = false;
				scope.m.hasEtrac = false;
			}
		}

		function vansCountIsZero() {
			return ((scope.m
				.vans48 ===
				null ||
				scope.m.vans48 === '0' ||
				scope.m.vans48 === '' ||
				scope.m.vans48 === 0) &&
			(scope.m.vans53 === null || scope.m.vans53 === '0' || scope.m.vans53 === '' || scope.m.vans53 === 0));
		}

		function flatbedsCountIsZero() {
			return ((scope.m.flatbeds48 === null ||
				scope.m.flatbeds48 === '0' ||
				scope.m.flatbeds48 === '' ||
				scope.m.flatbeds48 === 0) &&
			(scope.m.flatbeds53 === null ||
				scope.m.flatbeds53 === '0' ||
				scope.m.flatbeds53 === '' ||
				scope.m.flatbeds53 === 0));
		}

		function reefersCountIsZero() {
			return ((scope.m.reefers48 === null ||
				scope.m.reefers48 === '0' ||
				scope.m.reefers48 === '' ||
				scope.m.reefers48 === 0) &&
			(scope.m.reefers53 === null ||
				scope.m.reefers53 === '0' ||
				scope.m.reefers53 === '' ||
				scope.m.reefers53 === 0));
		}

		function isValidNumberOfOwnerOperators() {
			if (scope.m.numberOfOwnerOperators == null || scope.m.numberOfOwnerOperators === '') {
				scope.m.numberOfOwnerOperatorsError = 'Valid input is required';
				
				return false;
			} else {
				scope.m.numberOfOwnerOperatorsError = '';
			}
		}

		function onChangeHasDangerousGoods() {
			if (scope.m.hasDangerousGoods === false || scope.m.hasDangerousGoods === null) {
				scope.m.isHazmatCertified = false;
				scope.m.isRadioactiveCertified = false;
				scope.m.isResponsibleCareCarrier = false;
			}
		}

		function onChangeHasInternational() {
			if (scope.m.hasInternational === false || scope.m.hasInternational === null) {
				scope.m.isAceCertified = false;
				scope.m.isCtpatMember = false;
			}
		}

		function onChangeHasSecurityCerts() {
			if (scope.m.hasSecurityCerts === false || scope.m.hasSecurityCerts === null) {
				scope.m.isTwicCardholder = false;
				scope.m.isTsaRegistered = false;
			}
		}

		function onChangeHasEnvironmentalCerts() {
			if (scope.m.hasEnvironmentalCerts === false || scope.m.hasEnvironmentalCerts === null) {
				scope.m.isSmartWayCarrier = false;
				scope.m.isCarbCompliant = false;
				scope.m.is100PctCarbCompliant = false;
			}
		}

		function onChangeHasLtlCapabilities() {
			if (scope.m.hasLtlCapabilities === false || scope.m.hasLtlCapabilities === null) {
				scope.m.isParcel = false;
				scope.m.isUpsCarrier = false;
				scope.m.isLtlCapabilities = false;
				scope.m.isExpeditedGround = false;
				scope.m.isMultiStop = false;
			}
		}

		function onChangeHasDropOffPort() {
			if (scope.m.hasDropOffPort === false || scope.m.hasDropOffPort === null) {
				scope.m.isRailDrayage = false;
				scope.m.isPortDrayage = false;
				scope.m.portDrayageCities = null;
				scope.m.isAirCartage = false;
				scope.m.airCartageAirports = null;
			}
		}

		function onChangeIsPortDrayage() {
			if (scope.m.isPortDrayage === false || scope.m.isPortDrayage === null) {
				scope.m.portDrayageCities = null;
			}
		}

		function onChangeIsAirCartage() {
			if (scope.m.isAirCartage === false || scope.m.isAirCartage === null) {
				scope.m.airCartageAirports = null;
			}
		}

		function isValidNumberOfPowerUnits() {
			if (!scope.m.isBroker) {
				if (scope.m.numberOfPowerUnits == null || scope.m.numberOfPowerUnits === '') {
					scope.m.numberOfPowerUnitsError = 'Valid input is required';
					
					return false;
				} else {
					scope.m.numberOfPowerUnitsError = '';

					return true;
				}
			}
		}

		function isValidNumberOfOwnerOperators() {
			if (!scope.m.isBroker) {
				if (scope.m.numberOfOwnerOperators == null || scope.m.numberOfOwnerOperators === '') {
					scope.m.numberOfOwnerOperatorsError = 'Valid input is required';

					return false;
				} else {
					scope.m.numberOfOwnerOperatorsError = '';
				}
			}
		}

		function isValidNumberOfCompanyDrivers() {
			if (!scope.m.isBroker) {
				if (scope.m.numberOfCompanyDrivers == null || scope.m.numberOfCompanyDrivers === '') {
					scope.m.numberOfCompanyDriversError = 'Valid input is required';

					return false;
				} else {
					scope.m.numberOfCompanyDriversError = '';

					return true;
				}
			}
		}

		function isValidTrailerCounts() {
			if (!scope.m.hasNoTrailers) {
				if ((scope.m.vans48 != null && scope.m.vans48 !== '' && scope.m.vans48 >= 0) ||
				(scope.m.vans53 != null && scope.m.vans53 !== '' && scope.m.vans53 >= 0) ||
				(scope.m.flatbeds48 != null && scope.m.flatbeds48 !== '' && scope.m.flatbeds48 >= 0) ||
				(scope.m.flatbeds53 != null && scope.m.flatbeds53 !== '' && scope.m.flatbeds53 >= 0) ||
				(scope.m.reefers48 != null && scope.m.reefers48 !== '' && scope.m.reefers48 >= 0) ||
				(scope.m.reefers53 != null && scope.m.reefers53 !== '' && scope.m.reefers53 >= 0)) {
					scope.m.numberOfTrailersError = '';

					return true;
				}

				scope.m
					.numberOfTrailersError =
					'Enter at least one quantity for Number of Trailers or select the \'I have no trailers\' checkbox.  ';

				return false;
			}

			scope.m.numberOfTrailersError = '';

			return true;
		}

		function isFormValid() {
			isValidNumberOfCompanyDrivers();
			isValidNumberOfOwnerOperators();
			isValidNumberOfPowerUnits();
			isValidTrailerCounts();

			if (scope.m.numberOfCompanyDriversError === '' &&
				scope.m.numberOfOwnerOperatorsError === '' &&
				scope.m.numberOfPowerUnitsError === '' &&
				scope.m.numberOfTrailersError === '') {
				setSectionMessage(false);

				return true;
			}

			setSectionMessage(true);
			
			return false;
		}

		function saveData(callback) {
			if (scope.m.isDirty) {
				if (isFormValid()) {
					var trailers = [];
					var ports = [];
					var airports = [];

					if (scope.m.vans48 == 0 &&
						scope.m.vans53 == 0 &&
						scope.m.flatbeds48 == 0 &&
						scope.m.flatbeds53 == 0 &&
						scope.m.reefers48 == 0 &&
						scope.m.reefers53 == 0) {

						scope.m.vans48 = null;
						scope.m.vans53 = null;
						scope.m.flatbeds48 = null;
						scope.m.flatbeds53 = null;
						scope.m.reefers48 = null;
						scope.m.reefers53 = null;

						scope.m.hasNoTrailers = true;
					}

					if (scope.m.vans48 != null && scope.m.vans48 !== '') {
						if (scope.m.vans48 >= 0) {
							trailers.push({
								trailerType: 'Van48ft',
								numberOf: scope.m.vans48
							});
						}
					}

					if (scope.m.vans53 != null && scope.m.vans53 !== '') {
						if (scope.m.vans53 >= 0) {
							trailers.push({
								trailerType: 'Van53ft',
								numberOf: scope.m.vans53
							});
						}
					}

					if (scope.m.flatbeds48 != null && scope.m.flatbeds48 !== '') {
						if (scope.m.flatbeds48 >= 0) {
							trailers.push({
								trailerType: 'Flatbed48ft',
								numberOf: scope.m.flatbeds48
							});
						}
					}

					if (scope.m.flatbeds53 != null && scope.m.flatbeds53 !== '') {
						if (scope.m.flatbeds53 >= 0) {
							trailers.push({
								trailerType: 'Flatbed53ft',
								numberOf: scope.m.flatbeds53
							});
						}
					}

					if (scope.m.reefers48 != null && scope.m.reefers48 !== '') {
						if (scope.m.reefers48 >= 0) {
							trailers.push({
								trailerType: 'Reefer48ft',
								numberOf: scope.m.reefers48
							});
						}
					}

					if (scope.m.reefers53 != null && scope.m.reefers53 !== '') {
						if (scope.m.reefers53 >= 0) {
							trailers.push({
								trailerType: 'Reefer53ft',
								numberOf: scope.m.reefers53
							});
						}
					}

					if (scope.m.doubleDropCount != null && scope.m.doubleDropCount !== '') {
						if (scope.m.doubleDropCount >= 0) {
							trailers.push({
								trailerType: 'DoubleDrop',
								numberOf: scope.m.doubleDropCount
							});
						}
					}

					if (scope.m.containerCount != null && scope.m.containerCount !== '') {
						if (scope.m.containerCount >= 0) {
							trailers.push({
								trailerType: 'Container',
								numberOf: scope.m.containerCount
							});
						}
					}

					if (scope.m.movingVanCount != null && scope.m.movingVanCount !== '') {
						if (scope.m.movingVanCount >= 0) {
							trailers.push({
								trailerType: 'MovingVan',
								numberOf: scope.m.movingVanCount
							});
						}
					}

					if (scope.m.straightTruckCount != null && scope.m.straightTruckCount !== '') {
						if (scope.m.straightTruckCount >= 0) {
							trailers.push({
								trailerType: 'StraightTruck',
								numberOf: scope.m.straightTruckCount
							});
						}
					}

					if (scope.m.tankerCount != null && scope.m.tankerCount !== '') {
						if (scope.m.tankerCount >= 0) {
							trailers.push({
								trailerType: 'Tanker',
								numberOf: scope.m.tankerCount
							});
						}
					}

					if (scope.m.autoCarrierCount != null && scope.m.autoCarrierCount !== '') {
						if (scope.m.autoCarrierCount >= 0) {
							trailers.push({
								trailerType: 'AutoCarrier',
								numberOf: scope.m.autoCarrierCount
							});
						}
					}

					if (scope.m.dropStepDeckCount != null && scope.m.dropStepDeckCount !== '') {
						if (scope.m.dropStepDeckCount >= 0) {
							trailers.push({
								trailerType: 'DropStep',
								numberOf: scope.m.dropStepDeckCount
							});
						}
					}

					if (scope.m.lowBoyCount != null && scope.m.lowBoyCount !== '') {
						if (scope.m.lowBoyCount >= 0) {
							trailers.push({
								trailerType: 'Lowboy',
								numberOf: scope.m.lowBoyCount
							});
						}
					}

					if (scope.m.stretchTrailerCount != null && scope.m.stretchTrailerCount !== '') {
						if (scope.m.stretchTrailerCount >= 0) {
							trailers.push({
								trailerType: 'StretchTrailer',
								numberOf: scope.m.stretchTrailerCount
							});
						}
					}

					if (scope.m.dumpTrailerCount != null && scope.m.dumpTrailerCount !== '') {
						if (scope.m.dumpTrailerCount >= 0) {
							trailers.push({
								trailerType: 'DumpTrailer',
								numberOf: scope.m.dumpTrailerCount
							});
						}
					}

					if (scope.m.hopperBottomCount != null && scope.m.hopperBottomCount !== '') {
						if (scope.m.hopperBottomCount >= 0) {
							trailers.push({
								trailerType: 'HopperBottom',
								numberOf: scope.m.hopperBottomCount
							});
						}
					}


					if (scope.m.airCartageAirports != null) {
						airports = scope.m.airCartageAirports.split('\n');
					}

					if (scope.m.portDrayageCities != null) {
						ports = scope.m.portDrayageCities.split('\n');
					}

					var carrierId = getCarrierId();
					carrierRegistrationService.updateEquipmentInfo(carrierId,
						scope.m.hasNoTrailers,
						scope.m.hasInternational,
						scope.m.hasDangerousGoods,
						scope.m.hasSecurityCerts,
						scope.m.hasEnvironmentalCerts,
						scope.m.hasLtlCapabilities,
						scope.m.numberOfPowerUnits,
						scope.m.numberOfTeams,
						scope.m.numberOfOwnerOperators,
						scope.m.numberOfCompanyDrivers,
						scope.m.onBoardCommunications,
						trailers,
						scope.m.hasAirRide,
						scope.m.hasVented,
						scope.m.hasHotshot,
						scope.m.hasCurtains,
						scope.m.hasInsulated,
						scope.m.hasConestoga,
						scope.m.hasCoilRacks,
						scope.m.hasContainerLocks,
						scope.m.hasTarps,
						scope.m.hasEtrac,
						scope.m.hasGarmentRacks,
						scope.m.hasPadWrap,
						scope.m.hasStraps,
						scope.m.hasChains,
						scope.m.isHazmatCertified,
						scope.m.isRadioactiveCertified,
						scope.m.isResponsibleCareCarrier,
						scope.m.isAceCertified,
						scope.m.isCtpatMember,
						scope.m.isTwicCardholder,
						scope.m.isTsaRegistered,
						scope.m.isSmartWayCarrier,
						scope.m.isCarbCompliant,
						scope.m.is100PctCarbCompliant,
						scope.m.isParcel,
						scope.m.isUpsCarrier,
						scope.m.isLtlCapabilities,
						scope.m.isExpeditedGround,
						scope.m.isMultiStop,
						scope.m.isRailDrayage,
						scope.m.isPortDrayage,
						scope.m.isAirCartage,
						scope.m.isEdi,
						scope.m.isSpottedTrailers,
						scope.m.isLargeLoad,
						scope.m.isTrailerInterchange,
						scope.m.isPalletExchange,
						scope.m.isBrokerage,
						scope.m.otherServices,
						airports,
						ports,
						scope.m.hasDropOffPort)
						.then(function() {
							observerService
								.sendMessageToSubject(scope,
									subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_STATUS,
									'fleetServices');
							scope.m.isDirty = false;
							setSectionMessage(false);
							window.onbeforeunload = undefined;
							if (typeof (callback) === 'function')
								callback();
						})
						.catch(function(e) {
							console.log(e);
						});
				} else {
					setSectionMessage(true);
					scope.pendingCallback = callback;


				}
			} else {
				setSectionMessage(false);
				if (typeof (callback) === 'function')
					callback();
			}
		}

		function goToTab(tab) {
			observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_SET_PENDING_TAB, tab);
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_START_CHANGE_CARRIER_PROFILE_VIEW,
				navigate);
		}

		function setPendingTab(tab) {
			scope.tab = tab;
		}

		function navigate() {
			observerService.sendMessageToSubject(scope,
				subjectMessages.COB_SUBJECT_FINISH_CHANGE_CARRIER_PROFILE_VIEW,
				scope.tab);
		}

		function onForceGo() {
			if (typeof (scope.pendingCallback) === 'function')
				scope.pendingCallback();
		}

		function setSectionMessage(show) {
			scope.m.showSectionMessage = show;
			if (show) {
				$timeout(function () {
					$('.carrier-profile-wrapper')
						.animate({
							scrollTop: $('#error-summary').offset().top
						},
						200);
				},
				10);
			}
		}

		function loadDocuments() {
			var carrierId = getCarrierId();
			carrierRegistrationService.lookupCarrierDocuments(carrierId).then(function (response) {
				var documents = response.data.documents;
				scope.m.hazmatCertificates = carrierDocumentsService.getDocumentsByType(documents, HAZMAT_DOCUMENT_TYPE);
				scope.m.twicCards = carrierDocumentsService.getDocumentsByType(documents, TWIC_DOCUMENT_TYPE);
			});
		}

		function uploadTwicFile(file) {
			if (!file)
				return;

			var validationResult = carrierDocumentsService.validateFleetDocument(scope.m.twicCards, file);
			if (!validationResult.succeeded) {
				scope.m.twicUploadResult = validationResult;

				return;
			}

			uploadFile(file, TWIC_DOCUMENT_TYPE);
		}

		function uploadHazmatFile(file) {
			if (!file)
				return;

			var validationResult = carrierDocumentsService.validateFleetDocument(scope.m.hazmatCertificates, file);
			if (!validationResult.succeeded) {
				scope.m.hazmatUploadResult = validationResult;

				return;
			}

			uploadFile(file, HAZMAT_DOCUMENT_TYPE);
		}

		function uploadFile(file, type) {
			spinnerService.startSpinner(scope);

			carrierDocumentsService.getBase64DataUrl(file).then(function (url) {
				var documentFile = {
					documentName: file.name,
					mimeType: file.type,
					documentType: type,
					description: '',
					base64: url.split(',')[1]
				};

				var carrierId = getCarrierId();
				carrierDocumentsService.uploadDocument(documentFile, carrierId).then(function (response) {
					if (response.data.isSuccess) {
						if (type === HAZMAT_DOCUMENT_TYPE) {
							scope.m.hazmatCertificates.unshift(response.data.document);
							scope.m.hazmatFileUploadedRecently = true;
							scope.m.hazmatUploadResult = carrierDocumentsService.getResult(true);
						}
						else if (type === TWIC_DOCUMENT_TYPE) {
							scope.m.twicCards.unshift(response.data.document);
							scope.m.twicCardUploadedRecently = true;
							scope.m.twicUploadResult = carrierDocumentsService.getResult(true);
						}
					}
				}).finally(function () {
					spinnerService.stopSpinner(scope);
				});
			});
		}
	}

})();
